module.exports = __webpack_public_path__ + "static/media/5-c.8179caf8.jpg";